// base
import React from 'react';

// styles
import { themeOptions } from 'styles';

// libraries
import { css, Global } from '@emotion/react';

export const GlobalStyles: React.FC = () => (
  <Global
    styles={css`
      /* http://meyerweb.com/eric/tools/css/reset/
        v5.0.1 | 20191019
        License: none (public domain)
      */

      html,
      body,
      div,
      span,
      applet,
      object,
      iframe,
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      p,
      blockquote,
      pre,
      a,
      abbr,
      acronym,
      address,
      big,
      cite,
      code,
      del,
      dfn,
      em,
      img,
      ins,
      kbd,
      q,
      s,
      samp,
      small,
      strike,
      strong,
      sub,
      sup,
      tt,
      var,
      b,
      u,
      i,
      center,
      dl,
      dt,
      dd,
      menu,
      ol,
      ul,
      li,
      fieldset,
      form,
      label,
      legend,
      table,
      caption,
      tbody,
      tfoot,
      thead,
      tr,
      th,
      td,
      article,
      aside,
      canvas,
      details,
      embed,
      figure,
      figcaption,
      footer,
      header,
      hgroup,
      main,
      menu,
      nav,
      output,
      ruby,
      section,
      summary,
      time,
      mark,
      audio,
      video {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        font: inherit;
        vertical-align: baseline;
      }
      /* HTML5 display-role reset for older browsers */
      article,
      aside,
      details,
      figcaption,
      figure,
      footer,
      header,
      hgroup,
      main,
      menu,
      nav,
      section {
        display: block;
      }
      /* HTML5 hidden-attribute fix for newer browsers */
      *[hidden] {
        display: none;
      }
      body {
        line-height: 1;
      }
      menu,
      ol,
      ul {
        list-style: none;
      }
      blockquote,
      q {
        quotes: none;
      }
      blockquote:before,
      blockquote:after,
      q:before,
      q:after {
        content: '';
        content: none;
      }
      table {
        border-collapse: collapse;
        border-spacing: 0;
      }

      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      ::-webkit-scrollbar {
        width: 0;
      }

      ::-ms-reveal {
        display: none;
      }

      legend {
        display: none;
      }

      button {
        display: flex;
        padding: 0;
        border: 0;
        cursor: pointer;
        background-color: transparent;
      }

      input {
        padding: 9px 13px;
        color: #585959;
        border: 1px solid #dadada;
        border-radius: 6px;
        background-color: #ffffff;
      }

      input:disabled {
        background-color: #f8f8f8;
      }

      input::placeholder {
        color: #adadad;
      }

      input:focus-visible {
        outline: none;
      }

      img {
        max-width: 100%;
        border-style: none;
        vertical-align: middle;
      }

      body {
        font-family: 'Poppins', sans-serif;
        line-height: 1.3;
      }

      html {
        font-size: 14px;
        -webkit-font-smoothing: antialiased;
        -webkit-text-size-adjust: 100%;
        -moz-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%;
        -moz-osx-font-smoothing: grayscale;
      }

      //custom
      .reqSign {
        background-color: #ffedea;
        z-index: 9999;
        position: relative;
      }

      .denyForm {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 30px;
      }

      .cutton {
        position: absolute;
        height: 100%;
        background: gray;
        opacity: 0.05;
        width: 100%;
        top: 0px;
        z-index: 2;
      }

      .required {
        color: ${themeOptions.palette.error.main};
        p {
          position: absolute;
          transform: translateY(-50%);
          top: 55%;
          color: ${themeOptions.palette.error.main};
        }
      }
    `}
  />
);
